// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"29":"c5d1356a6ba5991262a4","975":"96264d9d90182328c7a1"}[chunkId] + ".min.js";
};